/**
 * Optional token refresh hook for user-service requests (registered from AuthProvider).
 */
let tokenRefreshHandler: (() => Promise<string | null>) | null = null;

export function setUserServiceTokenRefreshHandler(
  handler: (() => Promise<string | null>) | null,
): void {
  tokenRefreshHandler = handler;
}

export async function refreshAccessTokenForUserService(): Promise<string | null> {
  if (!tokenRefreshHandler) return null;
  return tokenRefreshHandler();
}
